import axios from "axios";
import config from "./api-config";
import qs from "qs";

export class ApiService {
  constructor(apiPath) {
    const baseURL = apiPath || config["search-edge"];
    this.requests = axios.create({
      baseURL,
      headers: { "Content-Type": "application/json" },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "comma" }),
    });
    this.requestRepeatArrays = axios.create({
      baseURL,
      headers: { "Content-Type": "application/json" },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
    });
  }

  get = (path, queryConfig = {}) => this.requests.get(path, queryConfig);

  getResults = (params) => {
    const path = "/api/search/v3/results";
    return this.requestRepeatArrays.get(path, { params });
  };

  getRagResults = async (params) => {
    const path = "/v1/rag";
    return this.requests.get(path, { params });
  };

  getResultsWithPremadeQuery = (queryString) => {
    const path = "/api/search/v3/results";
    return this.requestRepeatArrays.get(`${path}${queryString}`);
  };

  getSearch = (params, isBrowse) => {
    const path = isBrowse ? "/api/search/v2/browse" : "/api/search/v2";
    return this.requests.get(path, { params });
  };

  getMedia(params, type, isBrowse) {
    const path = isBrowse
      ? `/api/search/v2/browse/media/${type}`
      : `/api/search/v2/media/${type}`;
    return this.requests.get(path, { params });
  }

  async getCloudinaryToken() {
    const { data } = await this.requests({
      url: "/cloudinary-token",
      baseURL: "",
    });

    return data;
  }

  initErrorHandling = (callback) => {
    return this.requests.interceptors.response.use(undefined, () => {
      callback();
    });
  };
}

export default new ApiService();
